import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import AppRoutes from "@/routes";
import "@/index.css";
import twlIcon from "@/assets/twl_icon.svg";

function ensureFavicon() {
  if (typeof document === "undefined") {
    return;
  }
  const existing = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (existing) {
    existing.type = "image/svg+xml";
    existing.href = twlIcon;
    return;
  }
  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/svg+xml";
  link.href = twlIcon;
  document.head.appendChild(link);
}

ensureFavicon();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </React.StrictMode>
);

